<div class="content-editor"
     emojiPickerCloser
     [ngClass]="{
       'disabled': disabled,
       'enabled': !disabled,
       'editing': editing
     }">

  <ng-container [ngTemplateOutlet]="toolbarPlaceholder"></ng-container>

  <div class="sections"
       cdkDropList
       [ngClass]="{
         'all-blurred': (disabled || !(focused | async)),
         'any-focused': (!disabled && (focused | async)),
         'singular': singular
       }"
       (cdkDropListDropped)="reposition($event.previousIndex, $event.currentIndex)">

    <ng-container *ngFor="let section of sections; trackBy: trackById">

      <div class="content-editor-section section"
           cdkDrag
           cdkDragBoundary=".sections"
           [hidden]="!section.editorInitialized"
           [ngClass]="{
             'blurred': !section.focused.value,
             'focused': section.focused.value,
             'deselected': !section.selected,
             'selected': section.selected
           }">

        <div class="controls">

          <div class="actions"
               [hidden]="singular">

            <div class="action duplicate"
                 title="Duplicate section"
                 i18n-title="@@communication-centre.advertiser.communication-editor.message-composer.duplicate"
                 (click)="duplicate(section)">
              <span><i class="icon fa-regular fa-copy" aria-hidden="true"></i></span>
            </div>

            <div class="action delete"
                 title="Delete section"
                 i18n-title="@@communication-centre.advertiser.communication-editor.message-composer.delete"
                 (click)="delete(section)">
              <span><i class="icon fa-regular fa-trash-can" aria-hidden="true"></i></span>
            </div>

            <div class="action drag"
                 title="Move section"
                 i18n-title="@@communication-centre.advertiser.communication-editor.message-composer.move"
                 cdkDragHandle>
              <span><i class="icon fas fa-up-down-left-right" aria-hidden="true"></i></span>
            </div>

          </div>

          <div class="quill">

            <quill-editor bounds=".content-editor"
                          placeholder=""
                          [modules]="quillModules"
                          [strict]="true"
                          (onContentChanged)="enterEditingPhase()">

              <div class="toolbar"
                   overflowMarker
                   overflowSelectors=".ql-picker-options"
                   quill-editor-toolbar>
                <ng-container [ngTemplateOutlet]="toolbar"></ng-container>
              </div>

            </quill-editor>

          </div>

        </div>

      </div>

    </ng-container>

  </div>

</div>

<ng-template #toolbarPlaceholder>

  <div class="toolbar-placeholder" aria-hidden="true">

    <!-- This quill instance is used to render an extra copy of the toolbar.
         It both reserves the visual space that individual editor section toolbars will
         occupy upon selection and act's as a placeholder whilst sections are being sorted
         or when no sections are selected at all. -->

    <quill-editor disabled="true"
                  readOnly="true"
                  [modules]="quillModules">

      <div quill-editor-toolbar>
        <ng-container [ngTemplateOutlet]="toolbar"></ng-container>
      </div>

    </quill-editor>

    <div class="toolbar-placeholder-overlay"></div>

  </div>

</ng-template>
